import React from 'react'
import SIZE from '../../global/Size'
import COLOR from '../../global/Color'

import HeaderContainer from '../../components/header/HeaderContainer'
import HeaderTitle from '../../components/header/HeaderTitle'
import HeaderContentSmall from '../../components/header/HeaderContentSmall'
import SubHeading from '../../components/inner/venderProduct/SubHeading'
import ImageTextSmall from '../../components/inner/technologies/ImageTextSmall'
import TwoImage from '../../components/inner/technologies/TwoImage'
import TwoTitleWithImage from '../../components/inner/technologies/TwoTitleWithImage'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';

import DemsImage01 from '../../assets/technologies/demsImage01.png'
import DemsImage02 from '../../assets/technologies/demsImage02.png'
import DemsImage03 from '../../assets/technologies/demsImage03.png'
import DemsImage04 from '../../assets/technologies/demsImage04.png'
import DemsImage05 from '../../assets/technologies/demsImage05.png'
import DemsImage06 from '../../assets/technologies/demsImage06.png'
import DemsImage07 from '../../assets/technologies/demsImage07.png'
import DemsImage08 from '../../assets/technologies/demsImage08.png'
import DemsImage09 from '../../assets/technologies/demsImage09.png'
import DemsImage10 from '../../assets/technologies/demsImage10.png'
import DemsImage11 from '../../assets/technologies/demsImage11.png'
import styled from 'styled-components'

const Dems = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.technologies?.dems || siteCopy.en.pages.technologies.dems;

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>
        <div style={{width: '100%', display: 'flex', gap: 10, paddingTop: 60, paddingBottom: 60, justifyContent: 'space-between'}}>
          <DrivingLeftSideImageView>
            <img style={{width: '70%', objectFit: 'contain'}} src={DemsImage01}/>
          </DrivingLeftSideImageView>

          <DrivingRigthSideContentView>
            <p style={{fontSize: SIZE.LARGE, color: COLOR.MAGORELLEBLUE, fontWeight: 600}}>{copy.topTitle}</p>
            <span style={{lineHeight: 1.7}}>
              {renderLines(copy.topText)}
            </span>
          </DrivingRigthSideContentView>
        </div>

        <div style={{fontSize: SIZE.X05LARGE, fontWeight: 600 }}>{copy.statsTitle}</div>
        <div style={{width: '100%', display: 'flex', gap: 10, paddingBottom: 40, justifyContent: 'space-between'}}>
          <LeftSideImageView>
            <img style={{width: '50%', objectFit: 'contain'}} src={DemsImage02}/>
            <img style={{width: '50%', objectFit: 'contain'}} src={DemsImage03}/>
          </LeftSideImageView>
          <RigthSideContentView>
            <p style={{fontSize: SIZE.LARGE, color: COLOR.MAGORELLEBLUE, fontWeight: 600}}>{copy.topTitle}</p>
            <span style={{lineHeight: 2.2}}>
              {copy.statsItems?.map((item, index) => (
                <React.Fragment key={`${item.value}-${index}`}>
                  <span style={{ fontWeight: 700, color: COLOR.MAGORELLEBLUE }}>
                    {item.value}
                  </span>{" "}
                  {item.text}
                  <br />
                </React.Fragment>
              ))}
            </span>
            <p style={{color: COLOR.DARKGRAY}}>{copy.statsSource}</p>
          </RigthSideContentView>
        </div>

        <SubHeading>{copy.mountedTitle}</SubHeading>

        <MountedPhotosContainer>
          <ImageTextSmall Image={DemsImage04} Text={copy.mountedPhotos?.[0]}/>
          <ImageTextSmall Image={DemsImage05} Text={copy.mountedPhotos?.[1]}/>
          <ImageTextSmall Image={DemsImage06} Text={copy.mountedPhotos?.[2]}/>
          <ImageTextSmall Image={DemsImage07} Text={copy.mountedPhotos?.[3]}/>
        </MountedPhotosContainer>

        <SubHeading>{copy.partsTitle}</SubHeading>
        <TwoImage Image01={DemsImage08} Image02={DemsImage09}/>

        <HeaderContentSmall>
          {copy.parts?.map((part, index) => (
            <NamesFunctionsContainer key={index}>
              <span style={{fontWeight: 600, fontSize: SIZE.MEDIUM2, color: COLOR.MAGORELLEBLUE, paddingRight: 10}}>
                {part.label}
              </span>
              <span style={index === 2 ? {lineHeight: 2} : {}}>{renderLines(part.text)}</span>
            </NamesFunctionsContainer>
          ))}

          <TwoTitleWithImage
            Image01={DemsImage10}
            Title01={copy.title01}
            Image02={DemsImage11}
            Title02={copy.title02}/>
        </HeaderContentSmall>
      </HeaderContainer>
    </>
  )
}

const DrivingLeftSideImageView = styled.div`
  display: flex;
  width: 26%;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    display: none;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    display: none;
  }
`

const DrivingRigthSideContentView = styled.div`
  width: 74%;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    width: 100%;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    width: 100%;
  }
`

const LeftSideImageView = styled.div`
  padding-top: 2%;
  display: flex;
  width: 50%;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    display: none;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    display: none;
  }
`

const RigthSideContentView = styled.div`
  width: 54%;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    width: 100%;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    width: 100%;
  }
`

const MountedPhotosContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-bottom: 40px;
  gap: 20px;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    flex-direction: column;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    flex-direction: column;
  }
`

const NamesFunctionsContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  padding-bottom: 20px;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    flex-direction: column;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    flex-direction: column;
  }
`

export default Dems
